import { h } from "preact";
import { forwardRef } from "preact/compat";
import { ChevronToggle, Toggle } from "../../shared/components";
import LanguageSelect from "./LanguageSelect";
import { LanguageMap } from "../types/transcriptApiTypes";

import css from "./TranscriptToolbar.module.scss";
import { PoweredBy3Play } from "../../shared/components/PoweredBy3Play";

interface TranscriptToolbarProps {
  toggled: boolean;
  showToggle: boolean;
  showLanguageDropdown: boolean;
  onToggle: (val: boolean) => void;
  ref: HTMLInputElement;
  sortedLangs: LanguageMap;
  langChange: (val: string) => void;
}

const TranscriptToolbar = forwardRef<HTMLInputElement, TranscriptToolbarProps>(
  (
    {
      toggled,
      showToggle,
      showLanguageDropdown,
      onToggle,
      sortedLangs,
      langChange,
    },
    ref
  ) => {
    return (
      <form class={css.toolbar} id="transcript-controls">
        {showToggle ? (
          <ChevronToggle
            ref={ref}
            id="enable-transcript"
            toggled={toggled}
            onToggle={onToggle}
            label={toggled ? "Hide Transcript" : "Show Transcript"}
          />
        ) : (
          <div />
        )}
        {toggled && showLanguageDropdown && (
          <LanguageSelect sortedLangs={sortedLangs} langChange={langChange} />
        )}

        {!toggled && <PoweredBy3Play />}
      </form>
    );
  }
);
export default TranscriptToolbar;
